<template>
          <div class="app-header-nav-bar">
                <div class="spacer"></div>
                <div class="container">
                    <a href="event-schedule" class="your-account-nav-bar"> イベントスケジュール</a>
                </div>
        </div>

        <div class="app-header">
            <img class="session-detail-component-header-logo" src="./assets/elevate-logo.png" alt="Elevate logo" height="60">
        </div>

  <RouterView />
  <div class="app-footer">
      <div class="app-legal">
        <div class="app-legal-elevate-name">ELEVATE YOURSELF. ELEVATE OTHERS. ELEVATE EARTH.</div>
        <router-link :to="{ path: '/commercial-disclosure' }" class="app-legal-elevate-commercial-disclosure"><button class="app-legal-elevate-commercial-disclosure-button">特定商取引法に基づく表記</button></router-link>
      </div>
  </div>
</template>

<style scoped>

.app-footer {
    background: rgb(255, 255, 255);
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23E8E8E8FF' stroke-width='4' stroke-dasharray='2%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
}

.app-header-nav-bar {
        height: 10pt;
        width: auto;
        justify-content: space-between;
        align-items: left;
        padding-right: 10pt;
        display: flex;
        margin-top: 20px;
        /* background-color: rebeccapurple; */
    }

    .your-account-nav-bar {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 16pt;
        margin-right: 10px;
        margin-top: 16px;
    }
    .app-header {
        height: 100pt;
        width: 100%;
        justify-content: space-between;
        align-items: left;
        display: flex;
        margin-top: -20px;
    }
    
    .session-detail-component-header-logo {
        height: 40pt;
        align-items: left;
        object-fit: contain;
        display: flex;
        justify-content: left;
        padding-left: 20px;
    }


.app-legal {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.app-legal-elevate-name {
  font-family: SFPRoSemibold;
  font-size: 10pt;
  width: 50%;
}

.app-legal-elevate-commercial-disclosure {
  width: 50%;
  display: flex;
}

.app-legal-elevate-commercial-disclosure-button {
  font-family: SFPRoRegular;
  font-size: 10pt;
  cursor:pointer;
  border: none;
  background-color: transparent;
  text-decoration: underline;
  width: 100%;
  text-align: end;
}

/* @media only screen and (max-width: 1000px) {
    .container {
        display: flex;
        flex-direction: column;
   }
} */

</style>
